import { render } from "./TallyReportsPage.vue?vue&type=template&id=402d5f76&scoped=true"
import script from "./TallyReportsPage.vue?vue&type=script&lang=js"
export * from "./TallyReportsPage.vue?vue&type=script&lang=js"

import "./TallyReportsPage.vue?vue&type=style&index=0&id=402d5f76&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-402d5f76"]])

export default __exports__